var exports = {
  "v": "delaySkeletonLoad__oMxnnd",
};

module.exports = exports;
